import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/student-icon.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-c0e18aaa")

_pushScopeId("data-v-c0e18aaa")
const _hoisted_1 = { class: "h-full" }
const _hoisted_2 = { class: "main-panel flex-grow flex flex-col" }
const _hoisted_3 = { class: "flex-grow flex flex-col px-4 pt-6 overflow-y-scroll" }
const _hoisted_4 = { class: "mb-6 flex justify-between items-center" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "Student Icon",
  class: "w-12 h-12 mr-6 rounded-full"
}, null, -1)
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = { class: "text-lg font-bold" }
const _hoisted_9 = { class: "text-xs text-gray-400" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "個人データを編集", -1)
const _hoisted_11 = { class: "flex flex-row items-center justify-between mb-6" }
const _hoisted_12 = { class: "w-fit" }
const _hoisted_13 = {
  key: 0,
  class: "flex items-center p-3 rounded-md border-2 border-gray-200"
}
const _hoisted_14 = {
  key: 0,
  class: "mr-2 text-green-500"
}
const _hoisted_15 = {
  key: 1,
  class: "mr-2 text-yellow-300"
}
const _hoisted_16 = {
  key: 2,
  class: "text-sm font-medium text-gray-500"
}
const _hoisted_17 = {
  key: 3,
  class: "text-sm font-medium text-gray-500"
}
const _hoisted_18 = {
  key: 0,
  class: "flex"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("みんがく"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("ログイン情報印刷")
], -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("スクールAI"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("ログイン情報印刷")
], -1)
const _hoisted_21 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_22 = { class: "flex items-center justify-between" }
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { class: "font-bold" }, "管理人メモ", -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("span", null, "編集", -1)
const _hoisted_25 = { class: "mb-6" }
const _hoisted_26 = /*#__PURE__*/_createVNode("span", { class: "font-bold mb-1" }, "所属スクール・教室", -1)
const _hoisted_27 = { class: "mb-6" }
const _hoisted_28 = /*#__PURE__*/_createVNode("span", { class: "font-bold mb-1" }, "学年", -1)
const _hoisted_29 = { class: "mb-6" }
const _hoisted_30 = /*#__PURE__*/_createVNode("span", { class: "font-bold mb-1" }, "Googleアカウント", -1)
const _hoisted_31 = { class: "mb-6" }
const _hoisted_32 = /*#__PURE__*/_createVNode("span", { class: "font-bold mb-1" }, "Microsoftアカウント", -1)
const _hoisted_33 = { class: "mb-6" }
const _hoisted_34 = /*#__PURE__*/_createVNode("span", { class: "font-bold mb-2" }, "プロンプト作成", -1)
const _hoisted_35 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_36 = { class: "mb-6" }
const _hoisted_37 = /*#__PURE__*/_createVNode("span", { class: "font-bold mb-2" }, "先生へのメッセージ送信", -1)
const _hoisted_38 = { class: "mb-6" }
const _hoisted_39 = /*#__PURE__*/_createVNode("span", { class: "font-bold mb-1" }, "特徴", -1)
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { class: "whitespace-pre-wrap" }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = /*#__PURE__*/_createVNode("p", { class: "break-all" }, "-", -1)
const _hoisted_44 = { class: "mb-6" }
const _hoisted_45 = /*#__PURE__*/_createVNode("span", { class: "font-bold mb-1" }, "保護者向け入退室通知受信メール", -1)
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { class: "break-all" }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = /*#__PURE__*/_createVNode("p", { class: "break-all" }, "-", -1)
const _hoisted_50 = { class: "mb-6" }
const _hoisted_51 = /*#__PURE__*/_createVNode("span", { class: "font-bold mb-1" }, "授業日時", -1)
const _hoisted_52 = {
  key: 1,
  class: "mb-6"
}
const _hoisted_53 = /*#__PURE__*/_createVNode("span", { class: "font-bold mb-1" }, "polarデバイスID", -1)
const _hoisted_54 = { class: "font-bold max-w-lg mr-2 truncate" }
const _hoisted_55 = {
  key: 0,
  class: "border-2 border-gray-500 rounded-md text-gray-500 px-2 py-1"
}
const _hoisted_56 = {
  key: 1,
  class: "border-2 border-primary-500 rounded-md text-primary-500 px-2 py-1"
}
const _hoisted_57 = { class: "break-all" }
const _hoisted_58 = {
  key: 2,
  class: "mb-6"
}
const _hoisted_59 = /*#__PURE__*/_createVNode("span", null, "オリジナル情報の追加", -1)
const _hoisted_60 = {
  key: 3,
  class: "mb-6"
}
const _hoisted_61 = /*#__PURE__*/_createVNode("span", { class: "font-bold" }, "学習予定 (定期)", -1)
const _hoisted_62 = { class: "mb-6" }
const _hoisted_63 = { class: "flex items-center justify-between" }
const _hoisted_64 = /*#__PURE__*/_createVNode("span", { class: "font-bold" }, "今後の学習予定", -1)
const _hoisted_65 = /*#__PURE__*/_createVNode("span", null, "予約追加", -1)
const _hoisted_66 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MSPanelHeader = _resolveComponent("MSPanelHeader")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")
  const _component_m_reservation_card = _resolveComponent("m-reservation-card")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_MSPanelHeader, {
      "select-page": "profile",
      "can-edit-student": _ctx.canEditStudent,
      onOpen: _ctx.open
    }, null, 8, ["can-edit-student", "onOpen"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("div", _hoisted_7, [
              _createVNode("p", _hoisted_8, _toDisplayString(_ctx.student.data.name), 1),
              _createVNode("p", _hoisted_9, _toDisplayString(_ctx.loginId), 1)
            ])
          ]),
          (
              (_ctx.isAdminOfSchool || _ctx.isSupervisorOfSchool || _ctx.isEmployeeOfSchool) &&
                _ctx.canEditStudent
            )
            ? (_openBlock(), _createBlock(_component_m_button, {
                key: 0,
                color: "primary-500",
                "hover-color": "primary-600",
                onClick: _ctx.open
              }, {
                default: _withId(() => [
                  _createVNode(_component_m_icon, {
                    type: "pencil",
                    class: "mr-2"
                  }),
                  _hoisted_10
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            (_ctx.studentConfig)
              ? (_openBlock(), _createBlock("div", _hoisted_13, [
                  (_ctx.isLinkedToLINE)
                    ? (_openBlock(), _createBlock("div", _hoisted_14, [
                        _createVNode(_component_m_icon, {
                          type: "check-circle",
                          size: "5"
                        })
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_15, [
                        _createVNode(_component_m_icon, {
                          type: "warning",
                          size: "5"
                        })
                      ])),
                  (_ctx.isLinkedToLINE)
                    ? (_openBlock(), _createBlock("span", _hoisted_16, " LINE連携済 "))
                    : (_openBlock(), _createBlock("span", _hoisted_17, " LINE未連携の生徒です "))
                ]))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.hideLoginInvitaion)
            ? (_openBlock(), _createBlock("div", _hoisted_18, [
                (_ctx.isTutorOfSchool && !_ctx.inRecess)
                  ? (_openBlock(), _createBlock(_component_m_button, {
                      key: 0,
                      color: "primary-500",
                      text: "",
                      class: "hidden lg:flex",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.moveToPrint('auth')))
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_m_icon, {
                          type: "printer",
                          class: "mr-2"
                        }),
                        _hoisted_19
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.isTutorOfSchool && !_ctx.inRecess)
                  ? (_openBlock(), _createBlock(_component_m_button, {
                      key: 1,
                      color: "primary-500",
                      text: "",
                      class: "hidden lg:flex",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.moveToPrint('school_ai')))
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_m_icon, {
                          type: "printer",
                          class: "mr-2"
                        }),
                        _hoisted_20
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.isAdmin)
          ? (_openBlock(), _createBlock("div", _hoisted_21, [
              _createVNode("div", _hoisted_22, [
                _hoisted_23,
                _createVNode(_component_m_button, {
                  color: "secondary-500",
                  "hover-color": "secondary-600",
                  text: "",
                  onClick: _ctx.openCommentModal
                }, {
                  default: _withId(() => [
                    _createVNode(_component_m_icon, {
                      type: "pencil",
                      class: "mr-2"
                    }),
                    _hoisted_24
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createVNode("p", null, _toDisplayString(_ctx.comment), 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_25, [
          _hoisted_26,
          _createVNode("p", null, _toDisplayString(_ctx.classroomOfSchoolText), 1)
        ]),
        _createVNode("div", _hoisted_27, [
          _hoisted_28,
          _createVNode("p", null, _toDisplayString(_ctx.student.data.grade), 1)
        ]),
        _createVNode("div", _hoisted_29, [
          _hoisted_30,
          _createVNode("p", null, _toDisplayString(_ctx.role?.data.gmail ? _ctx.role.data.gmail : "-"), 1)
        ]),
        _createVNode("div", _hoisted_31, [
          _hoisted_32,
          _createVNode("p", null, _toDisplayString(_ctx.role?.data.microsoftEmail ? _ctx.role.data.microsoftEmail : "-"), 1)
        ]),
        _createVNode("div", _hoisted_33, [
          _hoisted_34,
          (!_ctx.allowStudentsToCreatePrompt)
            ? (_openBlock(), _createBlock("p", _hoisted_35, _toDisplayString(_ctx.allowStudentsToCreatePrompt === false
                ? `学校単位で許可されていません。`
                : ""), 1))
            : (_openBlock(), _createBlock("p", {
                key: 1,
                class: { 'text-red-500': _ctx.student.data.isPromptCreationDisabled }
              }, _toDisplayString(_ctx.student.data.isPromptCreationDisabled ? "不可" : "可"), 3))
        ]),
        _createVNode("div", _hoisted_36, [
          _hoisted_37,
          _createVNode("p", {
            class: {
              'text-red-500':
                _ctx.student.data.isStudentMessageSendingAllowed !== true
            }
          }, _toDisplayString(_ctx.student.data.isStudentMessageSendingAllowed === true
                ? "可"
                : "不可"), 3)
        ]),
        _createVNode("div", _hoisted_38, [
          _hoisted_39,
          (_ctx.characteristic.length > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_40, [
                _createVNode("p", _hoisted_41, _toDisplayString(_ctx.student.data.characteristic), 1)
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_42, [
                _hoisted_43
              ]))
        ]),
        _createVNode("div", _hoisted_44, [
          _hoisted_45,
          (_ctx.emailReceivers.length !== 0)
            ? (_openBlock(), _createBlock("div", _hoisted_46, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.student.data.emailReceivers, (emailReceiver) => {
                  return (_openBlock(), _createBlock("div", {
                    key: emailReceiver.index
                  }, [
                    _createVNode("p", _hoisted_47, _toDisplayString(emailReceiver), 1)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_48, [
                _hoisted_49
              ]))
        ]),
        _createVNode("div", _hoisted_50, [
          _hoisted_51,
          _createVNode("p", null, _toDisplayString(_ctx.classScheduleText), 1)
        ]),
        (
            _ctx.schoolConfig?.data.canUseLearningCard &&
              !!_ctx.student.data.polarDeviceId
          )
          ? (_openBlock(), _createBlock("div", _hoisted_52, [
              _hoisted_53,
              _createVNode("p", null, _toDisplayString(_ctx.student.data.polarDeviceId ?? "-"), 1)
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.customDatas, (data) => {
          return (_openBlock(), _createBlock("div", {
            key: data.title,
            class: "mb-6"
          }, [
            _createVNode("div", {
              class: ["flex items-center", {
              'mb-1':
                _ctx.isAdminOfSchool || _ctx.isSupervisorOfSchool || _ctx.isEmployeeOfSchool
            }]
            }, [
              _createVNode("span", _hoisted_54, _toDisplayString(data.title), 1),
              (data.showToStudent && !data.editableByStudent)
                ? (_openBlock(), _createBlock("div", _hoisted_55, " 生徒共有 "))
                : _createCommentVNode("", true),
              (data.showToStudent && data.editableByStudent)
                ? (_openBlock(), _createBlock("div", _hoisted_56, " 生徒編集可 "))
                : _createCommentVNode("", true),
              (
                (_ctx.isAdminOfSchool ||
                  _ctx.isSupervisorOfSchool ||
                  _ctx.isEmployeeOfSchool) &&
                  _ctx.canEditStudent
              )
                ? (_openBlock(), _createBlock(_component_m_button, {
                    key: 2,
                    color: "secondary-500",
                    "hover-color": "secondary-600",
                    text: "",
                    onClick: ($event: any) => (_ctx.openEditPropertyModal(data.title))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_m_icon, { type: "pencil" })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ], 2),
            _createVNode("p", _hoisted_57, _toDisplayString(data.value), 1)
          ]))
        }), 128)),
        (
            (_ctx.isAdminOfSchool || _ctx.isSupervisorOfSchool || _ctx.isEmployeeOfSchool) &&
              !_ctx.inRecess &&
              _ctx.canEditStudent
          )
          ? (_openBlock(), _createBlock("div", _hoisted_58, [
              _createVNode(_component_m_button, {
                color: "secondary-500",
                "hover-color": "secondary-600",
                text: "",
                onClick: _ctx.openAddPropertyModal
              }, {
                default: _withId(() => [
                  _createVNode(_component_m_icon, {
                    type: "plus",
                    class: "mr-2"
                  }),
                  _hoisted_59
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.regularlyReservations.length > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_60, [
              _hoisted_61,
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.regularlyReservations, (reservation) => {
                return (_openBlock(), _createBlock(_component_m_reservation_card, {
                  key: reservation.ref.id,
                  text: _ctx.textOfRegularlyReservation(reservation),
                  deletable: "",
                  class: "mt-3",
                  onDelete: ($event: any) => (_ctx.deleteRegularlyReservation(reservation.ref.id))
                }, null, 8, ["text", "onDelete"]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_62, [
          _createVNode("div", _hoisted_63, [
            _hoisted_64,
            (!_ctx.inRecess)
              ? (_openBlock(), _createBlock(_component_m_button, {
                  key: 0,
                  color: "secondary-500",
                  "hover-color": "secondary-600",
                  text: "",
                  onClick: _ctx.openReserve
                }, {
                  default: _withId(() => [
                    _createVNode(_component_m_icon, { type: "plus" }),
                    _hoisted_65
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.reservations.length == 0)
            ? (_openBlock(), _createBlock("p", _hoisted_66, "-"))
            : _createCommentVNode("", true),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.reservations, (reservation) => {
            return (_openBlock(), _createBlock(_component_m_reservation_card, {
              key: reservation.ref.id,
              text: _ctx.textOfReservation(reservation),
              deletable: "",
              class: "mt-3",
              onDelete: ($event: any) => (_ctx.deleteReservation(reservation.ref.id))
            }, null, 8, ["text", "onDelete"]))
          }), 128))
        ])
      ])
    ])
  ]))
})